import { formatLogValue } from '@/features/UserChangeLogModal/lib/formatLogValue';

type TimeLimitsPayload = {
  action?: string;
  packageId?: number | string | null;
  type?: 'limited' | 'unlimited_period' | string | null;
  secondsTotal?: number | string | null;
  expiresAt?: string | null;
  reason?: string | null;
};

const formatSecondsShort = (seconds: number | null | undefined): string => {
  if (!seconds || seconds <= 0) return '0м';
  const totalMinutes = Math.floor(seconds / 60);
  const hours = Math.floor(totalMinutes / 60);
  const minutes = totalMinutes % 60;

  if (hours > 0 && minutes > 0) return `${hours}ч ${minutes}м`;
  if (hours > 0) return `${hours}ч`;
  return `${minutes}м`;
};

const formatDateTimeShortRu = (input: string | null | undefined): string | null => {
  if (!input) return null;

  try {
    const normalized = input.includes('T') ? input : input.replace(' ', 'T') + 'Z';
    const date = new Date(normalized);
    if (isNaN(date.getTime())) return null;

    const dd = String(date.getDate()).padStart(2, '0');
    const mm = String(date.getMonth() + 1).padStart(2, '0');
    const yy = String(date.getFullYear()).slice(-2);
    const hh = String(date.getHours()).padStart(2, '0');
    const mi = String(date.getMinutes()).padStart(2, '0');

    return `${dd}.${mm}.${yy}, ${hh}:${mi}`;
  } catch {
    return null;
  }
};

const formatTimeLimits = (raw: unknown): string | null => {
  if (raw === null || raw === undefined) return null;
  const str = String(raw);
  if (!str.trim()) return null;

  let payload: TimeLimitsPayload | null = null;
  try {
    payload = JSON.parse(str) as TimeLimitsPayload;
  } catch {
    return str;
  }

  const action = payload?.action;
  if (action !== 'createPackage' && action !== 'spendTime') {
    return str;
  }

  const reason = payload?.reason ? String(payload.reason) : '';
  const expiresAt = formatDateTimeShortRu(payload?.expiresAt);

  if (action === 'spendTime') {
    const secondsTotalNum =
      payload?.secondsTotal !== null && payload?.secondsTotal !== undefined ? Number(payload.secondsTotal) : null;
    const amount =
      secondsTotalNum !== null && Number.isFinite(secondsTotalNum) ? `-${formatSecondsShort(secondsTotalNum)}` : '-0м';

    const parts: string[] = [`Списано времени: ${amount}`];
    if (reason) parts.push(`причина: ${reason}`);
    return parts.join(', ');
  }

  if (payload?.type === 'unlimited_period') {
    const parts: string[] = ['Добавлен безлимит'];
    if (expiresAt) parts.push(`истекает: ${expiresAt}`);
    if (reason) parts.push(`причина: ${reason}`);
    return parts.join(', ');
  }

  const secondsTotalNum =
    payload?.secondsTotal !== null && payload?.secondsTotal !== undefined ? Number(payload.secondsTotal) : null;
  const amount =
    secondsTotalNum !== null && Number.isFinite(secondsTotalNum) ? `+${formatSecondsShort(secondsTotalNum)}` : '+0м';

  const parts: string[] = [`Добавлен пакет: ${amount}`];
  if (expiresAt) parts.push(`истекает: ${expiresAt}`);
  if (reason) parts.push(`причина: ${reason}`);

  return parts.join(', ');
};

export const formatClubLogValue = (field: string, value: unknown): string => {
  if (field === 'timeLimits') {
    const formatted = formatTimeLimits(value);
    if (formatted === null || formatted === '') {
      return '—';
    }
    return formatted;
  }

  return formatLogValue(field, value);
};
